import { gql } from "@apollo/client";

export const OVERRIDE_METER_STATE_MUTATION = gql`
  mutation OverrideMeterState($overrideMeterData: OverrideStateInput!) {
    overrideMeterState(overrideMeterData: $overrideMeterData) {
      success
      error
    }
  }
`;
